import { render, staticRenderFns } from "./LeadTimeAdd.vue?vue&type=template&id=49624598&scoped=true"
import script from "./LeadTimeAdd.vue?vue&type=script&lang=js"
export * from "./LeadTimeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49624598",
  null
  
)

export default component.exports